module.exports = __webpack_public_path__ + "media/loginbg.a66cf65e.mp4";